import { useState, useEffect } from 'react'
import Navbar from './Navbar'
import Footer from './Footer'
import CookieBanner from './CookieBanner'
import ScrollToTop from './ScrollToTop'
import AccessibilityWidget from './AccessibilityWidget'

function QuickSidebar() {
  const [collapsed, setCollapsed] = useState(() =>
    typeof window !== 'undefined' && window.innerWidth < 1024
  )
  const [a11yOpen, setA11yOpen] = useState(false)

  useEffect(() => {
    const mql = window.matchMedia('(max-width: 1023px)')
    const onChange = (e) => { if (e.matches) setCollapsed(true) }
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return (
    <>
      <div className="ss-wrapper">
        <button
          className="ss-a11y-pill"
          onClick={() => setA11yOpen(v => !v)}
          aria-label="Abrir opções de acessibilidade"
          aria-expanded={a11yOpen}
          data-tooltip="Acessibilidade"
          style={{ position: 'relative' }}
        >
          <svg viewBox="0 0 45 45" width="36" height="36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="#fff" fillRule="evenodd" d="M22.5 11.25a2.578 2.578 0 1 0 0 5.156 2.578 2.578 0 0 0 0-5.156Zm-6.586 6.4a1.406 1.406 0 0 0-.89 2.669l6.07 2.023v3.248l-4.451 6.677a1.406 1.406 0 1 0 2.34 1.56L22.5 28.55l3.518 5.276a1.406 1.406 0 1 0 2.34-1.56l-4.451-6.677v-3.248l6.07-2.023a1.406 1.406 0 0 0-.89-2.669L22.5 19.846l-6.586-2.196Z" clipRule="evenodd" />
          </svg>
        </button>

        <nav
          className={`ss-sidebar${collapsed ? ' collapsed' : ''}`}
          aria-label="Atalhos de ação rápida"
        >
          <button
            className="ss-gaveta-handle"
            aria-label={collapsed ? 'Expandir atalhos' : 'Minimizar atalhos'}
            onClick={() => setCollapsed(v => !v)}
          >
            <svg viewBox="0 0 24 24" width="26" height="26" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" fill="white" />
            </svg>
          </button>

          <div className="ss-group">
            <a href="https://apav.pt/contactos" className="ss-group-icon" aria-label="Contactos" data-tooltip="Contactos">
              <svg viewBox="0 0 24 24" fill="white" width="26" height="26" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.62 10.79a15.466 15.466 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24 11.36 11.36 0 00.57 3.55 1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1 11.36 11.36 0 00.57 3.55 1 1 0 01-.24 1.01l-2.2 2.2z" />
              </svg>
            </a>

            <a href="https://chatbot.apav.pt" className="ss-group-icon" aria-label="Abrir Chatbot" data-tooltip="Chatbot" target="_blank" rel="noopener noreferrer">
              <svg viewBox="0 0 100 100" fill="none" stroke="white" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" width="26" height="26" xmlns="http://www.w3.org/2000/svg">
                <circle cx="50" cy="48" r="36" />
                <rect x="5" y="32" width="10" height="26" rx="5" />
                <rect x="85" y="32" width="10" height="26" rx="5" />
                <path d="M 10 58 C 10 78, 20 86, 42 86" />
                <rect x="42" y="80" width="16" height="12" rx="4" />
                <path d="M 30 43 Q 36 33 42 43" />
                <path d="M 58 43 Q 64 33 70 43" />
                <path d="M 40 64 Q 50 74 60 64" />
              </svg>
            </a>

            <a href="https://estatisticas.apav.pt" className="ss-group-icon" aria-label="Ver estatísticas" data-tooltip="Estatísticas">
              <svg viewBox="0 0 24 24" fill="white" width="26" height="26" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 22h2V10H4v12zm6 0h2V4h-2v18zm6 0h2V14h-2v8z" />
              </svg>
            </a>

          </div>

          <div className="ss-divider" />

          <div className="ss-exit-pill">
            <a href="https://www.google.com" className="ss-exit" aria-label="Sair do site rapidamente" data-tooltip="Sair Rápido">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 416.93 498.89" width="28" height="28">
                <path fill="white" d="M264.35,154.32c12.62-1.86,12.47-27.47-2.04-28.76-10.14-.91-24.12-.21-34.59,0-3.01.06-6.37,1.44-9.34-.03l-24.17-37.58c-1.8-2.12-3.79-3.96-6.3-5.21-8.19-4.1-23.81-9.19-32.89-12.11-13.68-4.39-33.05-1.17-47.61-.49-7.49.35-15.57-.3-23.05.5-4.21.45-7.81,2.79-9.53,6.69-5.66,16.44-16.39,33.1-21.86,49.3-5.85,17.31,16.05,29.7,25.65,13.61l18.27-40.86,28.56-1.53c.54.54-1.9,6.66-2.36,7.84-13.77,35.53-29.27,70.41-47.25,103.97-1.05,2.17-2.81,2.59-5.05,2.8-16.93,1.57-36.46-1.56-53.42-.04-16.87,1.51-19.01,28.03,1.07,30.89,21.45,3.05,47.53-1.08,69.47.41,2.84-1.05,5.47-2.18,7.41-4.62,7.23-9.1,12.35-25.23,19.22-35.2.36-.52.72-1,1.22-1.39l42.87,37.7,11.43,65.48c6.41,19.42,33.84,12.66,30.73-7.7-4.87-24.43-6.86-49.68-13.16-73.7-9.91-11-22.69-19.74-33.42-29.9-.74-.7-2.54-2.18-2.58-3.12l28.24-69.35c1.1-.2,1.44.71,2,1.4,6.41,7.95,11.81,20.77,18.49,28.08,4.24,4.64,8.48,4.15,14.33,4.03,14.83-.3,35.68.96,49.66-1.1Z"/>
                <path fill="white" d="M201.59,53.38c26.97-32.83-21.02-72.96-48.75-43.25-30.32,32.48,20.88,77.19,48.75,43.25Z"/>
                <path fill="white" d="M221.99,0l-.79.78v108.31l.79.78h9.42l.79-.78V11.51h155.43c-.15.67-.85,1.15-1.43,1.45-3.05,1.55-8.22,3.21-11.67,4.56-12.34,4.83-24.91,9.45-37.4,13.89-6.45,2.29-15.48,4.27-21.33,6.93-.65.3-1.12.53-1.34,1.28l-.06,101.7h23.32v-28.48l72.7,47.43-72.7,44.26v-27.08h-23.34l-.06,100.61c22.48,8.87,45.5,16.49,68.05,25.19,1.35.52,4.11,1.47,5.12,2.18.51.36.91.03.65,1.21h-155.17l-.78-.78v-134.47c-.33-.51-.72-.68-1.31-.79-1.25-.22-7.95-.71-8.82-.44l-.87.7v145.98l.79.78h194.68l.26-317.6h-194.94Z"/>
                <path fill="white" d="M0,356.26h79.22v32h-44.33v22.17h42.98v32h-42.98v24.48h44.33v32H0v-142.63Z"/>
                <path fill="white" d="M234.96,356.26l-43.56,67.46,49.34,75.17h-41.25l-30.84-50.5-29.3,50.5h-40.67l49.92-75.94-44.14-66.69h41.25l24.48,40.67,23.71-40.67h41.06Z"/>
                <path fill="white" d="M263.48,356.26h36.43v142.63h-36.43v-142.63Z"/>
                <path fill="white" d="M350.6,388.25h-28.14v-32h92.52v32h-27.95v110.64h-36.43v-110.64Z"/>
              </svg>
            </a>
          </div>
        </nav>
      </div>

      <AccessibilityWidget open={a11yOpen} onClose={() => setA11yOpen(false)} />
    </>
  )
}

export default function Layout({ children }) {
  return (
    <div className="flex flex-col min-h-screen">
      <ScrollToTop />
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[10001] focus:rounded-lg focus:bg-brand-700 focus:px-4 focus:py-2 focus:text-white focus:font-bold"
      >
        Saltar para o conteúdo
      </a>
      <Navbar />
      {/* tabIndex=-1 para o ScrollToTop poder mover-lhe o foco na mudança de rota */}
      <main id="main" tabIndex={-1} className="flex-grow pt-16 lg:pt-20 focus:outline-hidden">
        {children}
      </main>
      <Footer />
      <CookieBanner />
      <QuickSidebar />
    </div>
  )
}
